/**
 * Shared, credential-free error surface for the direct Parse session flow.
 *
 * The class is kept in its own module so callers (for example the Auth0
 * callback) can classify failures without importing the network-heavy session
 * client and without ever reading provider messages or tokens.
 */
export const PARSE_SESSION_ERROR_KIND = Object.freeze({
  UNSUPPORTED_IDENTITY: 'UNSUPPORTED_IDENTITY',
  AUTH0_SESSION: 'AUTH0_SESSION',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  UNKNOWN_IDENTITY: 'UNKNOWN_IDENTITY',
  ACCOUNT_CONFLICT: 'ACCOUNT_CONFLICT',
  BINDING_CONFLICT: 'BINDING_CONFLICT',
  INVALID_SESSION: 'INVALID_SESSION',
  TRANSIENT: 'TRANSIENT',
  CONFIGURATION: 'CONFIGURATION',
  // The Argo service-account access ended (PE-2215): the operator was already
  // sent to the «Sessione terminata» page, callers must only stop.
  OFC_ACCESS_ENDED: 'OFC_ACCESS_ENDED',
  UNEXPECTED: 'UNEXPECTED',
});

export class ParseSessionError extends Error {
  constructor(
    message,
    { kind = PARSE_SESSION_ERROR_KIND.UNEXPECTED, code, status } = {}
  ) {
    super(message);
    this.name = 'ParseSessionError';
    this.kind = kind;
    this.code = code;
    this.status = status;
  }
}

export const isOfcAccessEndedError = (error) =>
  error instanceof ParseSessionError &&
  error.kind === PARSE_SESSION_ERROR_KIND.OFC_ACCESS_ENDED;
